export function PageSkeleton() {
	return (
		<div className="flex min-h-screen items-center justify-center bg-bg-base">
			<div className="flex flex-col items-center gap-4">
				<div className="skeleton h-8 w-48 rounded-lg" />
				<div className="skeleton h-4 w-64 rounded-md" />
				<div className="skeleton h-4 w-56 rounded-md" />
			</div>
		</div>
	);
}
